import React from "react";
import MetaTags from "react-meta-tags";

const OnboardingMetaTags = ({title = 'RAFDownload the MSR app'}) => (
  <MetaTags>
    <title>{title}</title>
    <meta name="description" content="Get rewarded fairly for sharing data and completing surveys" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content="Get rewarded fairly for completing data tasks" />
  </MetaTags>
)

export default OnboardingMetaTags;
